import script from "./CustomToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomToggle.vue?vue&type=script&setup=true&lang=js"

import "./CustomToggle.vue?vue&type=style&index=0&id=00a3bedc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a3bedc"]])

export default __exports__